import React from "react";
import MobileTransferTemplatesTableAccordion from "../MobileTransferTemplatesTableAccordion";

import "./styles.css"

/**
 * @function MobileTransferTemplatesTable
 * @param {STRING} numOfItems - Displays the number of template items. 
 * @return {React.Component}
 * @exported true
 * @description This is the mobile transfer template table shown in TransferTemplatesPage
 */
export default function MobileTransferTemplatesTable(props) {
    const templates = props.templates ?? [];
    const numOfTemplates = templates.length;

    const rows = templates.reduce((acc, item) => {
        acc.push(
            <MobileTransferTemplatesTableAccordion key={ item.id } template={ item } />
        );
        return acc;
    }, []);

    return (
        <div className="mobile-transfer-templates-table show-on-mobile">
            { rows }
            <div className="transfer-templates-footer text-center">
                <span>{ 1 } - { numOfTemplates }  of { numOfTemplates } items</span>
            </div>
        </div>
    )
}


